import * as React from "react";
import { InstantCollapsible } from "sb-resp-ui";
import { SecondaryHeading } from "../SecondaryHeading";
import { HeadingTitle } from "../HeadingTitle";
export class SecondaryHeadingWrap extends React.PureComponent {
    renderSubheading() {
        return React.createElement(SecondaryHeading, { componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }));
    }
    render() {
        return (React.createElement(InstantCollapsible, { initiallyExpanded: this.props.shouldExpand, trigger: this.renderSubheading(), content: React.createElement(React.Fragment, null, this.props.children) }));
    }
}
//# sourceMappingURL=SecondaryHeadingWrap.js.map